import React from "react";
import { Box, Container, Typography } from "@mui/material";

export default function Footer() {
  return (
    <Box component="footer" sx={{ 
      mt: 4, 
      bgcolor: "grey.900", 
      color: "grey.200", 
      py: { xs: 3, sm: 4 } 
    }}>
      <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2 } }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="caption" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
            © {new Date().getFullYear()} Premium Catalog. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}